import React, { Component } from 'react';
import t from '../../utils/translateUtil';
import AddCardView from './AddCardView'
import crmservices from '../../wsclient/';
import ModalAlert from '../../components/ModalAlert'
import Loading from '../../components/Loading'
import { formatCreditCardNumber } from '../../utils/formatUtil';
class AddCard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            initLoad: true,
            showLoading: false,
            card_number: null,
            error: {},
        }
        this.onCloseAddCard = this.onCloseAddCard.bind(this)
        this.onSaveCard = this.onSaveCard.bind(this);
        this.showAlert = this.showAlert.bind(this)
    }
    async UNSAFE_componentWillMount() {
        console.log('XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX');
        //await this.onPrepareForm();
    }
    onCloseAddCard() {
        this.setState({ initLoad: true })
        this.props.onClose()
    }
    async onSaveCard(value) {
        console.log("A        value:",value);
        var card_number = value.card_number;
        if(card_number){
            card_number = formatCreditCardNumber(card_number);
        }
        card_number = card_number.replace(/ /g,'');
        this.setState({ showLoading: true });
        try {
            
            var getCardHashResult = await crmservices.jcccards.addCard(card_number);
            console.log("getCardHashResult:",getCardHashResult);

            if(getCardHashResult.code=='OK'){
                var data = getCardHashResult.data;
                var payload = {
                    card_token: data.card_no_hashed,
                    first6: (this.state.card_number.replace(' ','').substr(0, 6)),
                    last4: this.state.card_number.replace(' ','').substr(this.state.card_number.replace(' ','').length - 4, this.state.card_number.replace(' ','').length),
                }
                if(data.country_of_issue){
                    payload.country_of_issue = data.country_of_issue
                }
                var addPaymentMethodResult = await crmservices.contacts.addPaymentMethod(payload);
                if (addPaymentMethodResult.code == 'OK') {
                    this.showAlert('SUCCESS', t('ADD_NEW_CARD_SUCCESS'));
                    this.props.onClose();
                } else {
                    this.showAlert('ERROR', t('EXCEPTION_PROCESS'))
                }
            } else if (getCardHashResult.code=='CARD_ALREADY_EXIT') {
                this.showAlert('ERROR', t('CARD_ALREADY_EXIT'));
            } else {
                this.showAlert('ERROR', t('EXCEPTION_PROCESS'));
            }
        } catch (error) {
            console.log("onAddCard exception:", error);
            this.showAlert('ERROR', t('EXCEPTION_PROCESS'));
        }
        this.setState({ showLoading: false });
    }
    showAlert(status, message, title) {
        this.setState({
            showLoading: false,
            error: {
                showAlert: true,
                title: title,
                message: message,
                status: status,
            }
        })
    }
    render() {
        var {showLoading,error} = this.state;
        return (
            <div>
                <AddCardView
                    showLoading={this.state.showLoading}
                    open={this.props.open}
                    onCloseAddCard={this.onCloseAddCard}
                    onSaveCard={this.onSaveCard}
                    showAlert={this.showAlert}

                />
                <ModalAlert
                    open={error.showAlert}
                    onClose={() => this.setState({error:{}})}
                    hideHeader={true}
                    message={error.message}
                    error={error.status}
                    title={error.title}
                />
                {showLoading && <Loading showLoading={showLoading} />}
            </div>
        );
    }
}

export default AddCard;